﻿export const search = (function () {
    class Search {
        constructor(url) {
            if ("AbortController" in window) {
                this._controller = new AbortController;
                this._signal = this._controller.signal;
            }

            this._url = url;
        }
        async Do(searchStr, filterStr) {
            let _result;
            let _response;

            const requestData = { searchStr: searchStr, filter: filterStr, Interaction: "search" };

            if (this._controller !== undefined) {
                this._controller.abort();
            }

            if ("AbortController" in window) {
                this._controller = new AbortController;
                this._signal = this._controller.signal;
            }

            try {
                _response = await fetch(this._url, {

                    signal: this._signal,
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(requestData),

                });

                _result = await _response.json();

            } catch (err) {
                //console.log('aborted');
            }


            return _result;
        }
        async DoAndFun(searchStr, filterStr, fun) {

            const result = await this.Do(searchStr, filterStr);
            if (result !== undefined)
                fun(result);
        }

    }

    return {
        Search
    };
})();